
import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-900 via-purple-900/40 to-black relative overflow-hidden">
      {/* Enhanced Background Elements - Mobile Optimized */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-[300px] h-[300px] sm:w-[500px] sm:h-[500px] bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] sm:w-[600px] sm:h-[600px] bg-gradient-to-r from-cyan-500/15 to-blue-500/15 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-48 h-48 sm:w-80 sm:h-80 bg-gradient-to-r from-purple-500/10 to-cyan-500/10 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '4s' }}></div>
        
        {/* Floating Elements - Mobile Optimized */}
        <div className="absolute top-1/4 left-1/4 w-2 h-2 sm:w-3 sm:h-3 bg-purple-400 rounded-full animate-bounce opacity-60" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-3/4 right-1/4 w-3 h-3 sm:w-4 sm:h-4 bg-cyan-400 rounded-full animate-bounce opacity-40" style={{ animationDelay: '3s' }}></div>
        <div className="absolute top-1/2 right-1/3 w-1.5 h-1.5 sm:w-2 sm:h-2 bg-pink-400 rounded-full animate-bounce opacity-80" style={{ animationDelay: '5s' }}></div>
      </div>

      {/* Background Image Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/6ae41943072be130e246dbff45375075.jpg')`
        }}
      ></div>

      <div className="max-w-5xl mx-auto text-center relative z-10">
        {/* Enhanced Logo Section - Mobile Optimized */}
        <div className="flex items-center justify-center space-x-4 sm:space-x-6 mb-8 sm:mb-12">
          <div className="relative">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-purple-500 to-cyan-500 rounded-2xl sm:rounded-3xl flex items-center justify-center shadow-2xl shadow-purple-500/30">
              <img 
                src="https://static.readdy.ai/image/58c34b0b112df76c80b184053cb893a8/8c747b92224cceee656af4128cf2cd52.png" 
                alt="PepCoin Logo" 
                className="w-10 h-10 sm:w-14 sm:h-14 object-contain rounded-xl sm:rounded-2xl"
              />
            </div>
            <div className="absolute -inset-2 bg-gradient-to-r from-purple-500 to-cyan-500 rounded-2xl sm:rounded-3xl blur opacity-30 animate-pulse"></div>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
            <span className="bg-gradient-to-r from-white via-purple-200 to-cyan-200 bg-clip-text text-transparent">
              PepCoin
            </span>
          </h2>
        </div>

        {/* Enhanced Main Heading - Mobile Optimized */}
        <h3 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8 leading-tight px-4 sm:px-0">
          Ready to Start Your
          <br />
          <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent animate-pulse">
            Crypto Journey?
          </span>
        </h3>

        {/* Enhanced Description - Mobile Optimized */}
        <p className="text-base sm:text-xl md:text-2xl text-gray-200 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed font-light px-4 sm:px-0">
          Join thousands of traders who trust PepCoin for secure, profitable, and innovative cryptocurrency trading experiences.
          <span className="block mt-2 sm:mt-3 text-purple-300">Start your journey to financial freedom today.</span>
        </p>

        {/* Enhanced Action Buttons - Mobile Optimized */}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center mb-12 sm:mb-16 px-4 sm:px-0">
          <Link
            to="/auth/signup"
            className="group relative w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-gradient-to-r from-purple-500 via-pink-500 to-cyan-500 text-white rounded-2xl sm:rounded-3xl font-bold text-base sm:text-xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/40 whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10 flex items-center justify-center gap-2 sm:gap-3">
              <i className="ri-rocket-fill text-xl sm:text-2xl"></i>
              Create Free Account
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="absolute -inset-1 bg-gradient-to-r from-purple-500 to-cyan-500 rounded-2xl sm:rounded-3xl blur opacity-30 group-hover:opacity-50 transition-opacity duration-300"></div>
          </Link>

          <Link
            to="/trading"
            className="group w-full sm:w-auto flex items-center justify-center gap-2 sm:gap-3 px-8 sm:px-10 py-4 sm:py-5 bg-white/10 backdrop-blur-lg border-2 border-white/20 rounded-2xl sm:rounded-3xl font-bold text-base sm:text-xl text-white hover:bg-white/20 hover:border-purple-400/50 transition-all duration-300 hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-chart-line text-xl sm:text-2xl"></i>
            <span>Start Trading</span>
          </Link>
        </div>

        {/* Enhanced Trust Indicators - Mobile Optimized */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-4xl mx-auto px-4 sm:px-0">
          {[
            { 
              icon: 'ri-shield-check-line', 
              title: 'Bank-Grade Security', 
              desc: 'Your funds are protected with military-grade encryption',
              gradient: 'from-green-500 to-emerald-500'
            },
            { 
              icon: 'ri-customer-service-2-line', 
              title: '24/7 Expert Support', 
              desc: 'Professional help whenever you need assistance',
              gradient: 'from-blue-500 to-cyan-500'
            },
            { 
              icon: 'ri-award-line', 
              title: 'Industry Leading', 
              desc: 'Trusted by 500K+ users worldwide',
              gradient: 'from-purple-500 to-pink-500'
            },
          ].map((item, idx) => (
            <div key={idx} className="group text-center">
              <div className="relative mb-3 sm:mb-4">
                <div className={`w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r ${item.gradient} rounded-xl sm:rounded-2xl flex items-center justify-center mx-auto shadow-lg group-hover:shadow-xl transition-shadow duration-300`}>
                  <i className={`${item.icon} text-lg sm:text-2xl text-white`}></i>
                </div>
                <div className={`absolute -inset-1 bg-gradient-to-r ${item.gradient} rounded-xl sm:rounded-2xl blur opacity-0 group-hover:opacity-30 transition-opacity duration-300`}></div>
              </div>
              <h4 className="font-bold text-base sm:text-xl text-white mb-2 group-hover:text-purple-200 transition-colors duration-300">{item.title}</h4>
              <p className="text-gray-300 leading-relaxed group-hover:text-gray-200 transition-colors duration-300 text-sm sm:text-base">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Additional Stats - Mobile Optimized */}
        <div className="mt-12 sm:mt-16 pt-6 sm:pt-8 border-t border-white/10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
            {[
              { value: '$2.5B+', label: 'Trading Volume' },
              { value: '500K+', label: 'Active Users' },
              { value: '150+', label: 'Countries' },
              { value: '99.9%', label: 'Uptime' }
            ].map((stat, idx) => (
              <div key={idx} className="text-center">
                <div className="text-xl sm:text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent mb-1">
                  {stat.value}
                </div>
                <div className="text-gray-400 text-xs sm:text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
